import {
  ChangeDetectionStrategy,
  Component,
  contentChildren,
  CUSTOM_ELEMENTS_SCHEMA,
  ElementRef,
  viewChild,
  AfterViewInit,
  input
} from '@angular/core'

import { NgTemplateOutlet } from '@angular/common'
import Swiper from 'swiper'

import { options } from './data/options'
import { SlideItemDirective } from '@shared/directives/slider-item.directive'
import { SwiperOptions } from 'swiper/types'

@Component({
  selector: 'slider',
  imports: [NgTemplateOutlet],
  templateUrl: './slider.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SliderComponent implements AfterViewInit {
  pagination = input<boolean>(true)
  navigation = input<boolean>(false)
  breakpoints = input<Record<string, SwiperOptions> | undefined>(undefined)

  slider = viewChild<ElementRef>('slider')
  swiperInstance!: Swiper

  readonly sliderId = `slider-${Math.random().toString(36).substring(2, 9)}`

  slideItems = contentChildren(SlideItemDirective)

  ngAfterViewInit(): void {
    const slider = this.slider()
    if (!slider) return

    const sliderOptions = { ...options }

    if (this.navigation()) {
      sliderOptions.navigation = true
    }

    if (this.pagination()) {
      sliderOptions.pagination = {
        clickable: true,
        renderBullet: function (index: number, className: string) {
          return `<span class="${className}"></span>`
        },
        el: `#${this.sliderId}`
      }
    }

    if (this.breakpoints()) {
      sliderOptions.breakpoints = this.breakpoints()
    }

    this.swiperInstance = Object.assign(slider.nativeElement, sliderOptions)
    slider.nativeElement.initialize()
  }
}
